if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.current = 0

      // first item
      this.rotate()
      setInterval(() => {
        this.rotate();
      }, this.dataset.delay);
    }

    rotate() {
      const allItems = this.querySelectorAll('.announcement-bar__item');
      for (var i=0; i<allItems.length; i++) {
        var item = allItems[i]
        if (i == this.current) {
          item.style.display = "block";
        } else {
          item.style.display = "none";
        }
      }
      this.current++;
      if (this.current >= allItems.length) {
        this.current = 0;
      }
    }
  });
}